import { useState, useCallback } from "react";

export function useStepper(totalSteps = 3) {
  const [currentStep, setCurrentStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState(new Set());

  const completeStep = useCallback(
    (step) => {
      setCompletedSteps((prev) => {
        if (prev.has(step)) return prev; // avoid redundant re-renders
        return new Set([...prev, step]);
      });
      if (step < totalSteps) setCurrentStep(step + 1);
    },
    [totalSteps],
  );

  const reset = useCallback(() => {
    setCurrentStep(1);
    setCompletedSteps(new Set());
  }, []);

  return { currentStep, completedSteps, completeStep, reset };
}
